/**
 * @generated SignedSource<<03cbd5a79c64168e310f889d9b5126a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
import { FragmentRefs } from "relay-runtime";
export type TaskExecutionOptionsComponent$data = {
  readonly checkValue: TaskSentiment | null;
  readonly id: string;
  readonly task: {
    readonly sentiments: ReadonlyArray<TaskSentiment>;
  };
  readonly " $fragmentType": "TaskExecutionOptionsComponent";
};
export type TaskExecutionOptionsComponent$key = {
  readonly " $data"?: TaskExecutionOptionsComponent$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskExecutionOptionsComponent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskExecutionOptionsComponent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskCheck",
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sentiments",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkValue",
      "storageKey": null
    }
  ],
  "type": "TaskExecutionCheck",
  "abstractKey": null
};

(node as any).hash = "5f0a2970d3501946dc42cda9fd7829d2";

export default node;
